
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

    @Component({
      name: 'Modal'
    })
export default class Modal extends Vue {
      // #region Props
      @Prop({ default: null }) id!: string | null;
      @Prop({ default: true }) isFull!: boolean;
      @Prop({ default: true }) showCloseIcon!: boolean;
      @Prop({ default: false }) showLoader!: boolean;
      @Prop({ default: null }) target!: null | string;
      @Prop({ default: null }) show!: boolean | null;
      // #endregion

      // #region Methods

      element: HTMLElement | null = null;

      isOverflow = false;
      overflowTop = false;
      overflowBottom = false;

      mounted () {
        if (this.id && this.target) {
          this.relocateModal()
        }

        setTimeout(() => {
          this.setOverflow()
        }, 1)
      }

      // Handles shadow showing for overflow
      setOverflow () {
        const el = this.$refs[this.id + 'body'] as HTMLElement
        if (!el) {
          return
        }
        this.isOverflow = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth
        this.overflowBottom = Math.ceil(el.scrollTop) < Math.ceil(el.scrollHeight - el.offsetHeight)
        this.overflowTop = el.scrollTop !== 0
      }

      // Moves the modal to the defined element (this is useful for making full screen modals within other components)
      relocateModal () {
        const element = document.getElementById(this.id + 'element')
        const elementParent = element!.parentElement
        const destElement = document.getElementById('body')
				elementParent!.removeChild(element!)
				destElement!.appendChild(element!)
      }

      close () {
        this.$emit('close')
      }

      // #endregion

      @Watch('show')
      reset () {
        if (this.id && this.target) {
          this.relocateModal()
        }

        setTimeout(() => {
          this.setOverflow()
        }, 1)
      }
}
